module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-657d7599.png";